export enum AppMessageType {
  empty,
  successToast,
  infoToast,
  warningToast,
  errorToast,
}

export class AppMessage {
  public static empty = new AppMessage('', 5000, '', AppMessageType.empty);
  public header: string;
  public message: string;
  public messageType: AppMessageType;
  public toastDuration: number;
  public toastPosition: string;

  constructor(
    message: string,
    toastDuration: number,
    toastPosition: string,
    messageType: AppMessageType
  ) {
    this.message = message;
    this.toastDuration = toastDuration;
    this.toastPosition = toastPosition;
    this.messageType = messageType;
  }
}
